import { render, staticRenderFns } from "./NumericInput2.vue?vue&type=template&id=c095f24a&scoped=true&"
import script from "./NumericInput2.vue?vue&type=script&lang=js&"
export * from "./NumericInput2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c095f24a",
  null
  
)

export default component.exports